import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { InputWrapper, InputElement, Wrapper } from 'src/domains/layouts/shared/formComponents/input/Input.style';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';
import { InputError, InputLabel } from 'src/domains/layouts/shared/formComponents/FormComponents.style';

type InputType =
    | 'button'
    | 'checkbox'
    | 'color'
    | 'date'
    | 'datetime-local'
    | 'email'
    | 'file'
    | 'hidden'
    | 'image'
    | 'month'
    | 'number'
    | 'password'
    | 'radio'
    | 'range'
    | 'reset'
    | 'search'
    | 'submit'
    | 'tel'
    | 'text'
    | 'time'
    | 'url'
    | 'week';

const errorMessages = (errorsForView: Array<string>): Array<JSX.Element> => {
    const out = [];

    for (const [index, message] of errorsForView.entries()) {
        out.push(
            <InputError
                key={index}
                data-test='input-error'
            >
                {message}
            </InputError>
        );
    }
    return out;
};

interface PropsType {
    className?: string;
    label?: string;
    placeholder?: string;
    inputType?: InputType;
    isError?: boolean;
    isEmpty?: boolean;
    disabled?: boolean;
    currency?: boolean;
    hasLabelInside?: boolean;
    formInputState: FormInputState<string, unknown>;
    readOnly?: boolean;
    min?: string;
    max?: string;
    step?: string;
    maxLength?: number;
    autoFocus?: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    dataTest?: string;
}

export const Input = observer('Input', (props: PropsType) => {
    const {
        className,
        label,
        placeholder,
        inputType,
        isError,
        isEmpty,
        disabled,
        currency,
        hasLabelInside,
        formInputState,
        readOnly,
        maxLength,
        min,
        max,
        step,
        autoFocus,
        onChange,
        dataTest,
    } = props;

    const errorsForView = formInputState.errorsForView;

    const hasCurrency = currency !== undefined && formInputState.value.length > 0;

    return (
        <InputWrapper className={className}>
            <Wrapper>
                {label === undefined ? null : <InputLabel isEmpty={isEmpty}>{label}</InputLabel>}
                <InputElement
                    placeholder={placeholder}
                    value={formInputState.value}
                    hasCurrency={hasCurrency}
                    hasLabelInside={hasLabelInside}
                    type={inputType}
                    isError={isError}
                    isEmpty={isEmpty}
                    disabled={disabled}
                    min={min}
                    max={max}
                    step={step}
                    readOnly={readOnly}
                    maxLength={maxLength}
                    autoFocus={autoFocus}
                    onChange={
                        onChange === undefined
                            ? (e: React.ChangeEvent<HTMLInputElement>): void => formInputState.setValue(e.target.value)
                            : onChange
                    }
                    onBlur={formInputState.setAsVisited}
                    data-test={dataTest}
                />
            </Wrapper>
            {errorMessages(errorsForView)}
        </InputWrapper>
    );
});
